<template>
    <div class="grid-content align-items-center">
        <div class="grid-item no-flex">
            <v-select
                placeholder="Filter by label"
                :disabled="!hasLabels"
                :preserve-search="false"
                @input="selectFilter"
                :options="options"/>
        </div>
        <div class="grid-item grid-item-compact">
            <div
                v-for="(activeFilter, activeFilterIndex) in activeFilters"
                :key="activeFilterIndex"
                class="chip has-delete inline-s">
                <span>{{activeFilter | capitalize}}</span>
                <r-button type="link" @click="removeActiveFilter(activeFilter)">
                    <v-icon icon="close-s"/>
                </r-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {vSelect, vIcon} from '@/components/form';
    import _ from '@/common/helpers';

    export default {
        name: 'label-filter',
        components: {vSelect, vIcon},
        computed: {
            labels() {
                return this.$store.getters['rulesEngine/labels'];
            },
            hasLabels() {
                return this.labels.length > 0;
            },
            options() {
                return this.labels.map(label => ({label: _.capitalize(label), value: label}));
            },
        },
        data() {
            return {
                activeFilters: [],
            };
        },
        methods: {
            selectFilter(data = null) {
                if (data) {
                    this.activeFilters = [...new Set(this.activeFilters.concat([data]))];
                    this.$emit('select', this.activeFilters);
                }
            },
            removeActiveFilter(filter) {
                const set = new Set(this.activeFilters);
                set.delete(filter);
                this.activeFilters = [...set];
                this.$emit('select', this.activeFilters);
            },
        },
    };
</script>

<style scoped>

</style>
